import {Component, Input, OnInit, OnDestroy, ViewChild, Output, EventEmitter} from '@angular/core';
import {NgModel} from "@angular/forms";
import {GetAdjusterByClaimIdService} from "./services/get-adjuster-by-claim-id.service";
import {AdjusterDto} from "../../../../auto-generated-server-dtos/adjuster/claim/assign-to/adjuster-dto";
import {ClaimDto} from "../../../../auto-generated-server-dtos/claim/claim-dto";
import {ListAdjustersService} from "./services/list-adjusters.service";
import {AssignToService} from "./services/assign-to.service";
import {AssignToMeService} from "./services/assign-to-me.service";
import {AssignToStateService} from "./services/assign-to-state.service";
import {ClaimFormValidationService} from "../../../../claim/services/claim-form-validation.service";
import {v4 as uuidv4} from 'uuid';

@Component({
  selector: 'app-assign-to',
  templateUrl: './assign-to.component.html',
  styleUrls: ['./assign-to.component.scss']
})
export class AssignToComponent implements OnInit, OnDestroy {
  @Input() claimDto!: ClaimDto | null;

  adjusterId: string = '';
  adjustersList: AdjusterDto[] = [];
  adjusterLoading = true;
  adjustersListLoading = true;
  errorAdjusterList = false;
  errorAdjusterClaim = false;

  @ViewChild('adjusterIdSelect', { static: false }) adjusterIdSelect!: NgModel;
  private componentId = uuidv4();
  private isAdjusterValid = false;
  @Input() assignedAdjuster!: AdjusterDto | null;
  @Output() adjusterChanged = new EventEmitter<AdjusterDto>();

  constructor(
    private getAdjusterByClaimIdService: GetAdjusterByClaimIdService,
    private listAdjustersService: ListAdjustersService,
    private assignToService: AssignToService,
    private assignToMeService: AssignToMeService,
    private assignToStateService: AssignToStateService,
    private claimFormValidationService: ClaimFormValidationService,
  ) {
  }

  ngOnInit(): void {
    this.getAdjustersList();
    
    this.assignToStateService.selectedAdjuster$.subscribe(adjusterId => {
      if (adjusterId) {
        this.adjusterId = adjusterId;
      }
    });

    this.claimFormValidationService.formValidationEvent$.subscribe(() => {
      this.validateAdjusterSelect();
    });
  }

  ngOnDestroy(): void {
    this.claimFormValidationService.updateValidationResult(this.componentId, true);
  }

  private getAdjuster() {
    this.getAdjusterByClaimIdService.getAdjusterByClaimId(this.claimDto!.claimId).subscribe(
      adjusterDto => {
        this.adjusterLoading = false;
        this.adjusterChanged.emit(adjusterDto);
        this.adjusterId = adjusterDto?.userId ?? '';
        this.assignToStateService.setSelectedAdjuster(this.adjusterId);

        if (adjusterDto && !this.inAdjustersList(adjusterDto.userId)) {
          this.adjustersList.push(adjusterDto);
          this.sortAdjustersList();
        }
      },
      error => this.setErrorAdjusterClaim()
    );
  }

  private getAdjustersList() {
    this.listAdjustersService.listAdjusters().subscribe(
      adjustersList => {
        this.adjustersList = adjustersList;
        this.adjustersListLoading = false;
        this.getAdjuster();
      },
      error => this.setErrorAdjusterList()
    );
  }

  assignTo() {
    this.assignToService.assignTo(this.claimDto!.claimId, this.adjusterId).subscribe(
      {
        next: adjusterDto => {
          this.getAdjuster();
        },
        error: error => {
          this.setErrorAdjusterClaim();
        }
      });
  }

  assignToMe() {
    this.assignToMeService.assignToMe(this.claimDto!.claimId).subscribe(
      {
        next: adjusterDto => {
          this.getAdjuster();
        },
        error: error => {
          this.setErrorAdjusterClaim();
        }
      });
  }

  private inAdjustersList(userId: string): boolean {
    return this.adjustersList.some(adjuster => adjuster.userId === userId);
  }

  private sortAdjustersList() {
    this.adjustersList.sort((a, b) => {
      return a.name.localeCompare(b.name);
    });
  }

  private setErrorAdjusterClaim() {
    this.errorAdjusterClaim = true;
    this.adjusterLoading = false;
  }

  private setErrorAdjusterList() {
    this.errorAdjusterList = true;
    this.adjustersListLoading = false;
  }

  private validateAdjusterSelect() {
    this.adjusterIdSelect.control.markAsTouched();
    this.isAdjusterValid = !this.adjusterIdSelect.control.errors;
    this.claimFormValidationService.updateValidationResult(this.componentId, this.isAdjusterValid);
  }
  
}
